<template>
  <div class="container py-5" style="max-width: 800px; margin: auto;">
    <h1 class="mb-4">Política de Privacidade</h1>

    <p>
        A <span class="pp-strong">ATENTO</span>, responsável pela operação do sistema hospedado em
        <a href="https://www1.softwareatento.com.br" target="_blank" class="pp-link">https://www1.softwareatento.com.br</a>,
        reconhece a importância da privacidade e da proteção de dados pessoais. Esta Política de Privacidade estabelece de forma clara e transparente como tratamos os dados coletados,
        em especial os dados oriundos de integrações com serviços do Google via OAuth 2.0, em conformidade com a <span class="pp-strong">LGPD</span>,
        as Políticas de Privacidade da Google e demais legislações aplicáveis.
    </p>
    <h2 class="pp-subtitle">1. Finalidade do Sistema</h2>
    <p class="pp-paragraph">
      O Software Atento é uma plataforma de gestão voltada para clínicas e profissionais da área de <span class="pp-strong">Medicina do Trabalho</span>, com funcionalidades como:
    </p>
    <ul class="pp-list">
      <li>Agendamento de consultas e exames</li>
      <li>Emissão de laudos médicos</li>
      <li>Envio automatizado de comunicados, boletos e documentos</li>
      <li>Gestão de prontuários ocupacionais</li>
      <li>Integração com sistemas do eSocial</li>
    </ul>

    <h2 class="pp-subtitle">2. Dados Coletados</h2>
    <h3 class="pp-subtitle">2.1 Dados fornecidos pelo usuário:</h3>
    <ul class="pp-list">
      <li>Nome completo</li>
      <li>Endereço de e-mail</li>
      <li>Cargo ou função</li>
      <li>Nome da clínica ou empresa</li>
      <li>Dados de login</li>
    </ul>

    <h3 class="pp-subtitle">2.2 Dados de autenticação via Google (OAuth2):</h3>
    <p class="pp-paragraph">
      Ao autorizar o uso de funcionalidades do Google, coletamos os seguintes dados:
    </p>
    <ul class="pp-list">
      <li>Token de acesso temporário (OAuth2)</li>
      <li>Endereço de e-mail autenticado</li>
      <li>Permissão para envio de e-mails via Gmail (<code>https://www.googleapis.com/auth/gmail.send</code>)</li>
    </ul>

    <h2 class="pp-subtitle">3. Uso dos Dados</h2>
    <p class="pp-paragraph">
      Os dados são utilizados exclusivamente para autenticação, envio de laudos e comunicação clínica. Não são usados para publicidade ou fins analíticos externos.
    </p>

    <h2 class="pp-subtitle">4. Compartilhamento e Divulgação</h2>
    <p class="pp-paragraph">
      Os dados não são vendidos, alugados ou compartilhados com terceiros, exceto em casos exigidos por lei ou mediante ordem judicial.
    </p>

    <h2 class="pp-subtitle">5. Retenção e Exclusão de Dados</h2>
    <p class="pp-paragraph">
      Os dados são mantidos apenas enquanto forem necessários para os fins descritos. O usuário pode solicitar exclusão total a qualquer momento pelo e-mail:
      <a href="mailto:suporte@softwareatento.com.br" class="pp-link">suporte@softwareatento.com.br</a>.
    </p>

    <h2 class="pp-subtitle">6. Segurança da Informação</h2>
    <ul class="pp-list">
      <li>Conexões criptografadas (HTTPS/TLS)</li>
      <li>Armazenamento seguro de tokens</li>
      <li>Autenticação baseada em permissões</li>
      <li>Auditorias de segurança regulares</li>
    </ul>


    <h2 class="pp-subtitle">7. Direitos do Usuário (LGPD)</h2>
    <p class="pp-paragraph">Os usuários têm direito a:</p>
    <ul class="pp-list">
      <li>Acesso, correção e exclusão de dados</li>
      <li>Informações sobre o tratamento e compartilhamento</li>
      <li>Portabilidade e revogação de consentimento</li>
    </ul>

    <h2 class="pp-subtitle">8. Uso de Cookies</h2>
    <p class="pp-paragraph">
      Utilizamos cookies para autenticação de sessão e estatísticas internas. O usuário pode desativar cookies pelo navegador.
    </p>

    <h2 class="pp-subtitle">9. Alterações nesta Política</h2>
    <p class="pp-paragraph">
      Podemos atualizar esta política a qualquer momento. Alterações significativas serão destacadas na plataforma.
    </p>

    <h2 class="pp-subtitle">10. Contato</h2>
    <p class="pp-paragraph">
      Dúvidas ou solicitações podem ser enviadas para:
    </p>
    <ul class="pp-list">
      <li>E-mail: <a href="mailto:suporte@softwareatento.com.br" class="pp-link">suporte@softwareatento.com.br</a></li>
     
    </ul>
  </div>
</template>
<script>
export default {
  name: 'PoliticaPrivacidade'
}
</script>
<style src="./Style/style.css"></style>


// WEBPACK FOOTER //
// index.vue?fce8c1c2